import React, { useState , useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Form, Input, Typography } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { ROUTES } from '../../utils/constants';
import { toast } from "react-toastify";
import authApi from '../../api/auth';
import logo from '../../assets/logo.png';
import { useAuthHook } from '../../components/Auth/hooks/useAuth';

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const { isAuthenticated, login } = useAuthHook(); 
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(ROUTES.DASHBOARD);
    }
  }, [isAuthenticated, navigate]);

  const onFinish = async (values) => {
    setLoading(true);
    const response = await authApi.login(values);
    if (!response.success) {
      toast.error(response.message);
      setLoading(false);
    } else {
      await login(response.data.data.token, () => {
        setLoading(false);
        navigate(ROUTES.DASHBOARD);
      });
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f0f2f5',
      padding: '20px',
    }}>
      <Card
        style={{
          maxWidth: '420px',
          width: '100%',
          padding: 24,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          borderRadius: 8
        }}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src={logo} alt="Company Logo" style={{ width: '60%', height: '40%' }} />
        </div>

        <Form onFinish={onFinish} layout="vertical">
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input
              prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="Enter your username"
              size="large"
            />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="Enter your password"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
            >
              Sign In
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'center', marginTop: 8 }}>
            <Typography.Link onClick={() => navigate('/reset-password')}>
              Forgot password?
            </Typography.Link>
          </div>

          <div style={{ textAlign: 'center', marginTop: 8 }}>
            <Typography.Text>{"Don't have an account? "} </Typography.Text>
            <Typography.Link onClick={() => navigate('/signup')}>
              Create Account
            </Typography.Link>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default LoginPage;
